exports.version = require('./generatedVersion')